import { Style } from '@/components/style';
import { FormattedMessage } from 'react-intl';
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ReactComponent as Search } from '@/assets/img/fe_search.svg';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import ServeTypeUtils from '@/components/customizeWelcome/utils/serveTypeUtils';
import formatTWPhone from '@/utils/phoneUtils/formatTWPhone';
import {
  setWelcomeAreaCode,
  setWelcomeCustomerPhone,
} from '@/actions/customizeWelcome/customizeWelcomeAction';

const { secondaryColor } = new Style().getUiConfig();

type Params = { storeUuid: string };

function SearchBtnWelcome({ webStoreVo }) {
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const history = useHistory();
  const { storeUuid } = useParams<Params>();

  const customerPhone = useSelector<RootStateOrAny, any>(
    (state) => state.customizeWelcomeReducer.customerPhone
  );
  const selectedAreaCode = useSelector<RootStateOrAny, any>(
    (state) => state.customizeWelcomeReducer.selectedAreaCode
  );
  const pushToSearchOrder = () => {
    sessionStorage.setItem('previousUrl', JSON.stringify(location));
    const queryParams = new URLSearchParams(location.search);
    if (customerPhone) {
      queryParams.set('autoSearch', formatTWPhone(customerPhone));
      dispatch(setWelcomeCustomerPhone(formatTWPhone(customerPhone)));
    }
    if (selectedAreaCode.iti) {
      queryParams.set('areaCode', selectedAreaCode.iti);
      dispatch(setWelcomeAreaCode(formatTWPhone(selectedAreaCode.iti)));
    }
    queryParams.set('langs', webStoreVo.langs);
    history.push({
      pathname: `${process.env.REACT_APP_VERSION}/online/store/${storeUuid}/searchOrder`,
      search: `${queryParams}`,
      state: location.pathname,
    });
  };

  const isPostPay = (): boolean => {
    const { isPostPayEnable } = webStoreVo;
    return isPostPayEnable;
  };

  return (
    <div>
      {isPostPay() ||
      isEmpty(ServeTypeUtils.checkStoreServeTypeConfig(webStoreVo)) ? (
        <div />
      ) : (
        <div
          role="presentation"
          className="mt-3"
          style={{
            width: '100%',
          }}
          onClick={() => {
            pushToSearchOrder();
          }}
        >
          {/* 訂單查詢 點數查詢 */}
          {webStoreVo?.isRoyaltyEnable ? (
            <div
              className="fw-bolder d-flex justify-content-center align-items-center"
              style={{
                fontSize: '12px',
                border: `1px solid ${secondaryColor}`,
                borderRadius: '27px',
                height: '30px',
                width: '100%',
                color: secondaryColor,
              }}
            >
              <Search className="me-1" />
              <FormattedMessage id="welcome.search.order.and.redeem" />
            </div>
          ) : (
            <div
              className="fw-bolder d-flex justify-content-center align-items-center"
              style={{
                fontSize: '12px',
                border: `1px solid ${secondaryColor}`,
                borderRadius: '27px',
                height: '30px',
                width: '100%',
                color: secondaryColor,
              }}
            >
              <Search className="me-1" />
              <FormattedMessage id="common.searchOrder" />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

SearchBtnWelcome.defaultProps = { webStoreVo: {} };

SearchBtnWelcome.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  webStoreVo: PropTypes.any,
};

export default SearchBtnWelcome;
